import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  className?: string;
}

export default function LanguageToggle({ className = '' }: LanguageToggleProps) {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const toggleLanguage = () => {
    const next = currentLanguage === 'es' ? 'en' : 'es';
    i18n.changeLanguage(next);
    localStorage.setItem('preferredLanguage', next);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`btn btn-sm btn-outline-primary ${className}`}
      style={{ minWidth: 44, padding: '4px 10px', fontSize: 13, fontWeight: 600 }}
      type="button"
      title={currentLanguage === 'es' ? 'Switch to English' : 'Cambiar a Español'}
    >
      {currentLanguage === 'es' ? '🇲🇽 ES' : '🇺🇸 EN'}
    </button>
  );
}

// Hook para obtener el idioma actual desde cualquier componente
export function useCurrentLanguage(): string {
  const { i18n } = useTranslation();
  return i18n.language;
}
